import { BaseService } from "./baseService";
import httpRequest from ".";
import type { CustomerWxBindForm, CustomerWx } from "@zhihaoscm/entity";

export class CustomerWxService extends BaseService<unknown, unknown, any, any> {
    /** 微信绑定 */
    async bind(params: CustomerWxBindForm) {
        const { data } = await this.service.post(`${this.path}/bind`, params);
        return data as CustomerWx;
    }

    /** 微信解绑 */
    async untie(params: { customerId: number }) {
        const { data } = await this.service.post(`${this.path}/untie`, params);
        return data;
    }
}

export const customerWxService = new CustomerWxService("/customer/wx", httpRequest);
